<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.tank.title") + " " + tankId }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn @click="removeEvent" elevation="0" color="error" class="mr-2"
               v-if="tank != null && tank.tankType !== undefined">
          {{ $t("dialog.tank.remove") }}
        </v-btn>
        <v-btn @click="updateEvent" elevation="0" color="primary">
          {{ $t("dialog.tank.store") }}
        </v-btn>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-container class="pb-6">
        <validation-observer ref="form_validation">
          <form @submit.prevent="submit">
            <validation-provider
              v-slot="{ errors }"
              name="dialog.tank.vehicle_tank_type"
              rules="required"
            >
              <v-select
                v-model="tankType"
                :items="getVehicleTankTypes"
                :label="$t('dialog.tank.vehicle_tank_type')"
                :error-messages="errors"
                clearable
              >
                <template v-slot:selection="data">
                  {{ $t("enum.vehicle_tank_type." + data.item) }}
                </template>
                <template v-slot:item="data">
                  {{ $t("enum.vehicle_tank_type." + data.item) }}
                </template>
              </v-select>
            </validation-provider>

            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.tank.tank_calc_method"
                  rules="required"
                >
                  <v-select
                    v-model="calcMethod"
                    :items="getTankCalcMethods"
                    :label="$t('dialog.tank.tank_calc_method')"
                    :error-messages="errors"
                    clearable
                  >
                    <template v-slot:selection="data">
                      {{ $t("enum.tank_calc_method." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      {{ $t("enum.tank_calc_method." + data.item) }}
                    </template>
                  </v-select>
                </validation-provider>

                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.tank.fuel_type"
                  rules="required"
                >
                  <v-select
                    v-model="fuel"
                    :items="getFuelTypes"
                    :label="$t('dialog.tank.fuel_type')"
                    :error-messages="errors"
                    clearable
                  >
                    <template v-slot:selection="data">
                      {{ $t("enum.fuel_type." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      {{ $t("enum.fuel_type." + data.item) }}
                    </template>
                  </v-select>
                </validation-provider>
              </v-col>

              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.tank.capacity"
                  rules="required|min_value:1|max_value:100000"
                >
                  <v-text-field
                    v-model="capacity"
                    :error-messages="errors"
                    :label="$t('dialog.tank.capacity')"
                    clearable
                  ></v-text-field>
                </validation-provider>

                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.tank.start_state"
                  rules="required|min_value:0|max_value:100000"
                >
                  <v-text-field
                    v-model="startState"
                    :error-messages="errors"
                    :label="$t('dialog.tank.start_state')"
                    clearable
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row v-if="calcMethod === 'liter' || calcMethod === 'percent' || calcMethod === 'sensor'">
              <v-col class="my-0 py-0">
                <v-checkbox class="my-0 py-0"
                  v-model="needSuitableCondition"
                  :value="needSuitableCondition"
                  :label="$t('dialog.tank.need_condition')"
                  type="checkbox"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row v-if="calcMethod === 'liter' || calcMethod === 'percent'">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.tank.liter_factor"
                  rules="required|decimal:2"
                >
                  <v-text-field
                    v-model="calcFactor"
                    :error-messages="errors"
                    :label="$t('dialog.tank.liter_factor')"
                    clearable
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row v-else-if="calcMethod === 'sensor'">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.tank.sensor_nvalues"
                  rules="required|sensor_nvalues"
                >
                  <v-text-field
                    v-model="nvalues"
                    :error-messages="errors"
                    :label="$t('dialog.tank.sensor_nvalues')"
                    clearable
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </form>
        </validation-observer>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import utils from "@/utils";

export default {
  name: "TankDialog",

  data() {
    return {
      dialog: false,

      tank: null,
      tankId: 1,
      tankType: null,
      fuel: null,
      calcMethod: null,
      needSuitableCondition: true,
      capacity: null,
      startState: null,

      calcFactor: 1,
      nvalues: null
    };
  },

  methods: {
    open(tank) {
      this.tank = tank;
      this.tankId = tank.tankId;
      this.tankType = (tank.tankType === null || this.tankType === undefined) ? "main" : tank.tankType;
      this.fuel = tank.fuel;
      this.calcMethod = tank.calcMethod;
      this.needSuitableCondition = (tank.needSuitableCondition === null || this.needSuitableCondition === undefined) ? false : tank.needSuitableCondition;
      this.capacity = tank.capacity;
      this.startState = tank.startState;

      if (this.calcMethod === "liter" || this.calcMethod === "percent") {
        if (tank.parameters === null)
          this.calcFactor = "1";
        else
          this.calcFactor = utils.numberToString(tank.parameters.factor);
      } else if (this.calcMethod === "sensor") {
        this.nvalues = utils.nvaluesToString(tank.parameters);
      }

      this.dialog = true;

      if (this.$refs.form_validation !== undefined)
        this.$refs.form_validation.reset();
    },

    async updateEvent() {
      if (await this.$refs.form_validation.validate()) {

        this.tank.tankType = this.tankType;
        this.tank.fuel = this.fuel;
        this.tank.calcMethod = this.calcMethod;
        this.tank.needSuitableCondition = this.needSuitableCondition;
        this.tank.capacity = this.capacity;
        this.tank.startState = this.startState;

        if (this.calcMethod === "liter" || this.calcMethod === "percent") {
          this.tank.parameters = {
            factor: utils.toNumber(this.calcFactor)
          };
        } else if (this.calcMethod === "sensor") {
          this.tank.parameters = utils.stringToNValues(this.nvalues);
        }


        this.$emit("updated", this.tank);
        this.dialog = false;
      }
    },

    removeEvent() {
      this.$emit("updated", { tankId: this.tankId });
      this.dialog = false;
    }
  },
  computed: {
    getVehicleTankTypes() {
      return this.$store.state.data.listVehicleTankTypes;
    },

    getTankCalcMethods() {
      return this.$store.state.data.listTankCalcMethods;
    },

    getFuelTypes() {
      return this.$store.state.data.listFuelTypes;
    }
  },

  mounted() {
    this.$store.dispatch("data/fetchCodes", "vehicleTankTypes");
    this.$store.dispatch("data/fetchCodes", "tankCalcMethods");
    this.$store.dispatch("data/fetchCodes", "fuelTypes");
  }
};
</script>